export function formatRange(d1: Date, d2: Date, locale = "en-US") {
  return new Intl.DateTimeFormat(locale, {
    month: "long",
    day: "numeric",
    year: "numeric",
    // @ts-ignore
  }).formatRange(d1, d2);
}
